import { ApiBase } from "config";
import { ListResponse } from "common/models/baseModel";
import {
  IindustryWiseMemberResult,
  IMemberLoginHistory,
  IMemberLoginHistoryPostModel,
  IMemberStatusCountGridPostModel,
  IMemberStatusResult,
  IMemberWiseTableResults,
  IYearWiseMemberGridPostModel,
  IYearWiseMemberResult,
  IPendingApprovalCounts,
  ILoginHistoryPostModel,
  ILoginHistoryRecord,
} from "./types";
import api from "utils/api";

const baseUrl = `${ApiBase}/api/Dashboard`;

function getMemberStatusCount(model: IMemberStatusCountGridPostModel) {
  return api.post<IMemberStatusResult>(
    `${baseUrl}/getTotalMembers`,
    model.filter
  );
}

function getYearWiseMemberCount(model: IYearWiseMemberGridPostModel) {
  return api.post<IYearWiseMemberResult>(
    `${baseUrl}/getYearWiseMemberCount`,
    model.filter
  );
}

function getLogedInMembers(model: IMemberLoginHistoryPostModel) {
  return api.post<IMemberLoginHistory>(
    `${baseUrl}/getLogedInMembers`,
    model.filter
  );
}

function getLoginHistoryList(model: ILoginHistoryPostModel) {
  return api.post<ListResponse<ILoginHistoryRecord>>(
    `${baseUrl}/getLoginHistoryList`,
    model
  );
}

function getMemberWiseTables() {
  return api.get<IMemberWiseTableResults>(
    `${baseUrl}/getMemberWiseTables`
  );
}

function getIndustryWiseMember() {
  return api.get<IindustryWiseMemberResult>(
    `${baseUrl}/getIndustryWiseMember`
  );
}

function getPendingApprovalCounts() {
  return api.get<IPendingApprovalCounts>(
    `${baseUrl}/getPendingApprovalCounts`
  );
}

export default {
  getMemberStatusCount,
  getLogedInMembers,
  getLoginHistoryList,
  getMemberWiseTables,
  getIndustryWiseMember,
  getYearWiseMemberCount,
  getPendingApprovalCounts
};
